import React, { useState } from "react";
import Modal from "components/modal";
import Button from "components/button";
import { useDispatch, useSelector } from "react-redux";
import { splitContainerItem } from "store/containerSlice";
import InputField from "components/fields/InputField";
import { showToast } from "components/toast";
import LoaderButton from "components/button/LoaderButton";

function SplitItemModal({ isOpen, onClose, item, refreshList }) {
  const dispatch = useDispatch();
  const { splitContainerItemLoading, splitContainerItemError } = useSelector(
    (state) => state.containers
  );

  const [splitQty, setSplitQty] = useState("");

  const handleSplit = async () => {
    if (!splitQty || splitQty <= 0) {
      showToast?.error("Please enter a valid quantity");
      return;
    }

    if (splitQty >= item?.totalQty) {
      showToast?.error("Split quantity must be less than total quantity");
      return;
    }

    try {
      const response = await dispatch(
        splitContainerItem({
          containerItemId: item?._id,
          splitQty: Number(splitQty),
        })
      );

      if (
        response?.payload?.statuscode === 201 ||
        response?.payload?.statuscode === 200
      ) {
        onClose();
        refreshList?.();
        setSplitQty("");
      } else {
        console.error(
          "Split failed:",
          response?.payload?.msg || "Unknown error"
        );
      }
    } catch (error) {
      console.error("Split failed:", error);
    }
  };

  const remainingQty =
    item?.totalQty && splitQty ? item.totalQty - Number(splitQty) : null;

  const handleQtyChange = (e) => {
    const value = Number(e.target.value);

    if (value > item?.totalQty - 1) {
      setSplitQty(item?.totalQty - 1);
    } else if (value < 0) {
      setSplitQty("");
    } else {
      setSplitQty(value);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} className="max-w-lg">
      <h2 className="border-b py-3 pl-2 text-xl font-bold text-navy-700 dark:text-white">
        Split Item
      </h2>

      <div className="space-y-3 p-4">
        {/* Product Info */}
        <div className="flex items-center gap-4">
          <img
            src={item?.picture || item?.orderItem?.picture}
            alt={item?.name || "Product"}
            className="h-20 w-20 rounded border object-cover"
          />
          <div>
            <p className="text-lg font-semibold text-navy-700 dark:text-white">
              {item?.name || "Unnamed Item"}
            </p>
            <p className="text-sm  text-navy-700 dark:text-white">
              {item?.description || "No description"}
            </p>
            <p className="text-sm text-navy-700 dark:text-white">
              Total Quantity: <strong>{item?.totalQty || 0}</strong>
            </p>
          </div>
        </div>

        {/* Split Input */}
        <InputField
          id="split"
          variant="auth"
          type="number"
          label={`Enter Split Quantity`}
          placeholder="Enter quantity to split"
          value={splitQty}
          min={1}
          max={item?.totalQty - 1}
          onChange={handleQtyChange}
        />

        {remainingQty !== null && (
          <p className="text-sm text-navy-700 dark:text-white">
            Remaining Quantity after split:{" "}
            <strong>{remainingQty >= 0 ? remainingQty : 0}</strong>
          </p>
        )}
        {splitContainerItemError && (
          <p className="mt-2 text-sm text-red-500">{splitContainerItemError}</p>
        )}

        {/* Buttons */}
        <div className="mt-4 flex justify-end gap-2">
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <LoaderButton
            isLoading={splitContainerItemLoading}
            onClick={handleSplit}
          >
            Split
          </LoaderButton>
        </div>
      </div>
    </Modal>
  );
}

export default SplitItemModal;
